import axios from './defaultAxios';
import qs from 'qs';
import config from  '../configuration';
import {isEmpty} from 'utils';
import {ENTITY_STATE_DELETE} from 'utils/constants';

const Host = `${config.api.schema}://${config.api.host}:${config.api.port}`;
const Url = Host + '/api/v1';

const paramsSerializer = p => qs.stringify(p, { allowDots: true });

const httpGet = async (action, params) => {
  return (await axios.get(`${Url}/${action}`, {params: params, paramsSerializer, headers: {'Pragma': 'no-cache'}})).data;
};

const httpPut = async (action, body) => {
  return (await axios.put(`${Url}/${action}`, body)).data;
};

const httpPost = async (action, body, headers) => {
  return (await axios.post(`${Url}/${action}`, body, {headers})).data;
};

const httpPath = async (action, body, headers) => {
  return (await axios.patch(`${Url}/${action}`, body, {headers})).data;
};

const httpDelete = async (action, params, headers) => {
  return (await axios.delete(`${Url}/${action}`, {params: params, paramsSerializer, headers})).data;
};

export async function getCollectionCasePage({page, count, sort, filter}) {
  return await httpGet('collector/collectionCase', {page, count, sort, filter});
}

export async function getDictionary(include) {
  return await httpGet('collector/dictionary', {include});
}

export async function getComments(collectionCaseId) {
  return await httpGet(`collector/collectionCase/${collectionCaseId}/comment`);
}

export async function addComment({collectionCaseId, text, publicFlag, personId}) {
  return await httpPost(`collector/collectionCase/${collectionCaseId}/comment`, {text, publicFlag}, {userId: personId});
}

export async function setComment({collectionCaseId, commentId, text, publicFlag, personId}) {
  return await httpPath(`collector/collectionCase/${collectionCaseId}/comment/${commentId}`, {text, publicFlag}, {userId: personId});
}

export async function delComment({collectionCaseId, commentId, personId}) {
  return await httpDelete(`collector/collectionCase/${collectionCaseId}/comment/${commentId}`, null, {userId: personId});
}

export async function getCollectionCaseCreditPage(collectionCaseId, params) {
  return await httpGet(`collector/collectionCase/${collectionCaseId}/credit`, params);
}

export async function getCollectionCase(id) {
  const results = await Promise.all([
    httpGet(`collector/collectionCase/${id}`),
    httpGet(`cession/collectionCase/${id}/penalty`),
    httpGet(`cession/collectionCase/${id}/legalCost`)
  ]);

  let collectionCase = results[0];
  const penalty = results[1] && results[1].penaltyList && results[1].penaltyList[0];
  const legalCosts = results[2] && results[2].legalCostList;

  if (penalty || legalCosts) collectionCase = {...collectionCase, penalty, legalCosts};

  return collectionCase;
}

export async function patchCollectionCase(collectionCase, userId) {
  const collectionCaseId = collectionCase.id;
  const collectionCasePatch = {};
  if (!isEmpty(collectionCase.collectionCaseStateId)) collectionCasePatch.collectionCaseStateId = collectionCase.collectionCaseStateId;
  if (!isEmpty(collectionCase.creditDealStateId)) collectionCasePatch.creditDealStateId = collectionCase.creditDealStateId;
  if (!isEmpty(collectionCase.nextMonitoringDate)) collectionCasePatch.nextMonitoringDate = collectionCase.nextMonitoringDate;
  if (!isEmpty(collectionCase.attachFiles)) collectionCasePatch.attachFiles = collectionCase.attachFiles;
  if (!isEmpty(collectionCase.credits)) collectionCasePatch.credits = collectionCase.credits;
  if (!isEmpty(collectionCase.debtCollectionProbability)) collectionCasePatch.debtCollectionProbability = collectionCase.debtCollectionProbability;
  if (!isEmpty(collectionCase.claimDirectedToBorrower)) collectionCasePatch.claimDirectedToBorrower = collectionCase.claimDirectedToBorrower;
  if (!isEmpty(collectionCase.claimDirectedToCourt)) collectionCasePatch.claimDirectedToCourt = collectionCase.claimDirectedToCourt;

  const penalty = collectionCase.penalty;
  if (penalty && !penalty.sum) penalty.sum = 0;
  const penaltyPut = penalty && {penaltyList: [penalty]};

  const legalCostsPut = collectionCase.legalCosts && {legalCostList: collectionCase.legalCosts
      .filter(a => !!a && a.state !== ENTITY_STATE_DELETE)
      .map(a => {if (!a.sum) return {...a, sum: 0}; return a;})};

  let legalCostsDelete = collectionCase.legalCosts &&collectionCase.legalCosts
    .filter(a => a && a.state === ENTITY_STATE_DELETE)
    .map(a => a.id)
    .filter(a => !isEmpty(a));
  if (legalCostsDelete.length <= 0) legalCostsDelete = null;

  const res = await httpPath(`collector/collectionCase/${collectionCaseId}`, collectionCasePatch, {userId});

  await Promise.all([
    penaltyPut && httpPut(`cession/collectionCase/${collectionCaseId}/penalty`, penaltyPut),
    legalCostsPut && httpPut(`cession/collectionCase/${collectionCaseId}/legalCost`, legalCostsPut),
    legalCostsDelete && httpDelete(`cession/collectionCase/${collectionCaseId}/legalCost?${legalCostsDelete.map(a => `legalCostId=${a}`).join('&')}`),
  ]);

  return res;
}

export const fetchFile = async ({file, fileId}, options) => {
  //возвращается идентификатор файла
  const formData = new FormData();
  formData.append("file", file);

  const promise = ((options && options.axios) || axios).post(`${Url}/file/${fileId}`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
  const r = await promise;

  return r.data;
};


export async function deleteFile(fileId) {
  return httpDelete(`file/${fileId}`);
}

export function getDownloadFileLink(fileId) {
  if (!fileId) return null;
  return `${Url}/file/${fileId}`;
}


// WEBPACK FOOTER //
// ./src/api/debtCollectionMonitor.js